import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  'Chat-Message-Date-Divider': {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '24px 0px',
    width: '100%',
    padding: '0px 16px',
    '& .divider-wrapper': {
      width: '100%'
    },
    '& .divider': { width: '100%' },
    '& .date': {
      minWidth: '100px',
      margin: '0px 16px'
    }
  },

  'Chat-Message-Bubble-root': {
    display: 'flex',
    padding: '0px 16px',
    width: '100%',
    '& .bubble-container': {
      display: 'flex',
      marginLeft: 'initial',
      '&.owner': {
        marginLeft: 'auto'
      }
    },
    '& .bubble-wrapper': {
      display: 'flex',
      flexDirection: 'column'
    },
    '& .bubble-content': {
      display: 'flex'
    },
    '& .manager-name': {
      maxWidth: 230
    }
  },

  'Chat-Message-Bubble-Adorment': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    marginLeft: 8,
    marginRight: 0,
    '& .MuiTypography-colorTextSecondary': {
      color: colorSet.gray600
    },
    '&.owner': {
      marginLeft: 0,
      marginRight: 8
    }
  },

  'Chat-Message-Bubble-Common-root': {
    maxWidth: 230,
    width: 'fit-content',
    padding: 16,
    backgroundColor: colorSet.gray000,
    borderRadius: '0px 10px 10px 10px',
    '&.owner': {
      backgroundColor: colorSet.primary300,
      borderRadius: '10px 0px 10px 10px'
    },
    '& .primary-text': {
      fontWeight: 500,
      color: colorSet.primary500
    },
    '& .long-text': {
      wordBreak: 'break-all',
      whiteSpace: 'break-spaces'
    },
    '& .hyperlink': {
      textDecoration: 'underline',
      color: colorSet.primary600,
      cursor: 'pointer',
      fontSize: 14,
      fontWeight: 400
    },

    '&.quotation-bubble': {
      '& .divider': {
        width: '100%',
        margin: '16px 0px'
      },
      '& .title': {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 8,
        '& img': {
          width: 20,
          height: 20,
          marginRight: 6
        }
      },
      '& .startIcon': {
        '& img': {
          width: 24,
          height: 24
        }
      },
      '& .buttonLabel': {
        justifyContent: 'space-between',
        whiteSpace: 'nowrap'
      }
    }
  },
  'Chat-Message-Bubble-Prgoress-root': {
    width: 230,
    borderRadius: 10,
    backgroundColor: colorSet.gray000,
    '& .header': {
      borderRadius: '10px 10px 0px 0px',
      padding: '10px 16px',
      color: colorSet.gray000,
      backgroundColor: colorSet.primary500
    },
    '& .contentWrapper': {
      padding: '0px 16px 16px 16px'
    },
    '& .content': {
      paddingTop: 16,
      borderTop: `1px solid ${colorSet.gray200}`
    },
    '& .wordBreak': {
      wordBreak: 'break-all'
    },
    '& .footer': {
      padding: 16
    }
  }
}));

export default useStyles;
